// @flow

import React from 'react';
import classnames from 'classnames';
import styles from './styles.module.scss';

type Props = {
  children?: Node,
  color?: string,
}

const RoundContainer = ({ children, color = 'white' }: Props) => (
  <div className={classnames(styles.container, styles[color])}>
    {children}
  </div>
);

export default RoundContainer;
